document.addEventListener('DOMContentLoaded', function() {
    // forms() já é inicializado globalmente em main.js — não chamar de novo aqui,
    // ou o submit do form roda duas vezes (envio duplicado).

    // Get the form
    const form = document.querySelector('.needs-validation');

    // Phone mask handler
    const phoneInput = document.querySelector('#phone');
    if (phoneInput) {
        phoneInput.addEventListener("input", function (e) {
            let value = e.target.value.replace(/\D/g, ""); // Remove tudo que não for número

            if (value.length > 11) {
                value = value.slice(0, 11); // Limita a 11 dígitos
            }

            // Formata o número de telefone corretamente
            if (value.length > 2) {
                value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
            }
            if (value.length > 10) {
                value = `${value.slice(0, 10)}-${value.slice(10)}`;
            }

            e.target.value = value; // Atualiza o valor do input com a máscara
        });
    }

    // Form validation
    form.addEventListener('submit', function(event) {
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }

        form.classList.add('was-validated');
    });
});
